import { Action } from 'redux';

import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { OpenManageItemsInCollectionsDialog } from '../../AppActionTypes';

export interface ManageItemsInCollectionsDialogAction extends Action {
  targetItems: IContentInfo[];
  targetCollectionLuids?: string[];
}

export function openManageItemsInCollectionsDialogAction(
  targetItems: IContentInfo[],
  targetCollectionLuids?: string[],
): ManageItemsInCollectionsDialogAction {
  return {
    type: OpenManageItemsInCollectionsDialog,
    targetItems,
    targetCollectionLuids,
  };
}
